// developed by Param Partap Singh
import React from 'react'
import Nav from '../Utils/Nav'
import banner from "../Assets/background2.JPG";
import '../Css/network.css'
// import vpn from '../Assets/vpn-configuration.pdf'
import vpn_window from '../Assets/VPN Installation Guide for Windows and Mac Systems.pdf'
import vpn_linux from '../Assets/VPN Installation Guide for Linux Ubuntu System.pdf'
import ip from '../Assets/ip-add.pdf'
import dns from '../Assets/dns-server.pdf'
import Footer from "../Utils/Footer";

export default function Network() {
  return (
    <>
    <Nav/>
    <div className="main-container">
        <div className="banner">
            <img className="background" src={banner} alt="" />
        <h1 className="main-heading-title">Network Services</h1>
        </div>

        <div className="page-content">
          <p>
          IIT Ropar has a Local area network, wireless network with IP telephony to cater the needs of students, faculty and staff in academic as well as residential areas. The complete LAN solution has 3 layers architecture. 10 Gigabit Core with redundancy, Dual homed Distribution layer with redundancy and dual PoE (Power on Ethernet) enabled Access layer. High speed and uninterrupted Internet access is provided across the campus to everyone through multiple ISP (Internet Service Provider) leased lines provided by BSNL(2 Gbps), and Vodafone idea (2 Gbps). For any network related issue network support is available 9 AM to 6 PM.
          </p>
        </div>


        <div className="lower-container">
        
        <div className="box-containt">
            <div className="box-n">
                <h2>VPN Service</h2>
                <ul>
                    <li>A virtual private network (VPN) extends a private network across a public network and enables users to send and receive data across shared or public networks as if their computing devices were directly connected to the private network. Please visit the respective campus link for VPN access.</li>
                     {/* <a href={vpn} className='btn-n-1' target='_blank'><button className='btn-p-1'>Click Here</button></a> */}
                     <a href={vpn_window} className='btn-n-1' target='_blank'><button className='btn-p-1'>For Win/Mac</button></a>
                     <a href={vpn_linux} className='btn-n-2' target='_blank'><button className='btn-p-2'>For Linux</button></a>
                </ul>    
            </div>
            <div className="box-n">
                <h2>Building-wise IP Address Allocation Details</h2>
                <ul>
                    <li>The below list provides the building wise IP Address scheme throughout the campus.</li>
                    <div className='btn-div'>
                       <a href={ip} className='btn-n' target='_blank'><button className='btn-p'>Click Here</button></a>
                    </div>
                </ul>
            </div>
            <div className="box-n">
                <h2>Request for static IP address(private)</h2>
                <ul>
                    <li>Please raise a ticket/request in our helpdesk portal.</li>
                    <a href="https://www.iitrpr.ac.in/itsupport/" className='btn-n' target='_blank'><button className='btn-p'>Raise Ticket</button></a>
                </ul>
            </div>
            <div className="box-n">
                <h2>Request for IP Telephone</h2>
                <ul>
                    <li>Please raise a ticket/request in our helpdesk portal.
                    </li>
                    <a href="https://www.iitrpr.ac.in/itsupport/" className='btn-n' target='_blank'><button className='btn-p'>Raise Ticket</button></a>
                    
                </ul>
            </div>
            <div className="box-n">
                <h2>Main Campus DNS server setting</h2>
                <ul>
                    <li>Please cross check your DNS settings in your browser and system, if you are unable to open IIT Ropar website, medh website inside main campus.
                    </li>
                    <a href={dns} className='btn-n'><button className='btn-p'>Click Here</button></a>
                </ul>
            </div>
            
        </div>
        </div>
        
    
    </div>
    <Footer/>
    </>
  )

}
